<template>
  <div class="page-container">
    <!-- Content Wrapper START -->
    <div class="main-content">
      <div class="page-header">
        <h2 class="header-title">Contact Queries</h2>
        <div class="header-sub-title">
          <nav class="breadcrumb breadcrumb-dash">
            <router-link :to="`/`" class="breadcrumb-item">
              <i class="anticon anticon-home m-r-5"></i>Home >
            </router-link>
            <span class="breadcrumb-item active">Contact Queries</span>
          </nav>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <div class="m-t-25">
            <section v-if="!isLoading">
              <div class="row">
                <div class="col-lg-12 add-form">
                  <input class="form-control datatable_search" @keyup="searchDatatable" placeholder="Search..."/>
                </div>
              </div>
              <table class="dataTable table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Date Added</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="contactQuery in contactQueries" :key="contactQuery.id">
                    <td>{{contactQuery.name}}</td>
                    <td>{{contactQuery.email}}</td>
                    <!-- <td><a href="javascript:void(0)" @click="updateSelectedComment(contactQuery.comment, contactQuery.name)" data-toggle="modal" data-target="#exampleModal">View Message</a></td> -->
                    <td>
                      <span v-show="0">{{new Date(contactQuery.created_at).getTime()}}</span>
                      {{contactQuery.created_at}}
                    </td>
                    <td>
                      <i class="fa fa-trash fa-icons" @click="deleteContactQuery(contactQuery.id)" aria-hidden="true"></i>
                      <router-link :to="'/query/' + contactQuery.id">
                      <i class="fa fa-reply fa-icons" aria-hidden="true"></i></router-link>
                    </td>
                  </tr>
                </tbody>
                <tfoot></tfoot>
              </table>
            </section>
            <div class="main-loader" v-else>
              <MainLoader></MainLoader>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Content Wrapper END -->
  </div>
</template>

<script>
/* eslint-disable no-undef */
import ContactQuery from '@/models/ContactQuery'
export default {
  name: 'ContactQueries',
  data () {
    return {
      datatable: null,
      modal: {
        comment: null,
        title: null
      },
      contactQueries: []
    }
  },
  computed: {
    isLoading () {
      if (this.contactQueries.length === 0) { return this.$store.getters.apiStatus === 'loading' } else return false
    }
  },
  mounted () {
    let dataTableScript = document.createElement('script')
    dataTableScript.setAttribute('src', 'https://cdn.datatables.net/1.10.22/js/jquery.dataTables.min.js')
    document.head.appendChild(dataTableScript)

    let naturalScript = document.createElement('script')
    naturalScript.setAttribute('src', 'https://cdn.datatables.net/plug-ins/1.10.16/sorting/natural.js')
    document.head.appendChild(naturalScript)
    this.fetchAllContactQueries()
  },
  methods: {
    fetchAllContactQueries () {
      this.contactQueries = []
      this.$store.dispatch('fetchAllContactQueries')
        .then((result) => {
          result.data.contactQueries.forEach(contactQuery => {
            this.contactQueries.push(new ContactQuery(contactQuery))
          })
          setTimeout(() => this.initDatatables(), 100)
        })
        .catch((err) => this.$helper.catchHandler(err))
      setTimeout(() => this.initDatatables(), 100)
    },
    deleteContactQuery (id) {
      this.$confirm(
        {
          message: `Are you sure you want to delete this query?`,
          button: { no: 'No', yes: 'Yes' },
          callback: confirm => {
            if (confirm) {
              this.$store.dispatch('deleteContactQuery', id)
                .then((result) => {
                  this.$toast.success(result.data.message)
                  this.fetchAllContactQueries()
                })
                .catch((err) => this.$toast.error(err.response.data.message))
            }
          }
        }
      )
    },
    updateSelectedComment (comment, title) {
      this.modal.title = title
      this.modal.comment = comment
    },
    searchDatatable (e) {
      this.datatable.search(e.target.value).draw()
    },
    initDatatables () {
      this.datatable = $('table').DataTable({
        destroy: true,
        stateSave: true,
        pagingType: 'full_numbers',
        columnDefs: [
          {
            targets: 3,
            'orderable': false
          }
        ],
        stateSaveCallback: function (settings, data) {
          localStorage.setItem('DataTables_accounts_page', JSON.stringify(data))
        },
        stateLoadCallback: function (settings) {
          return JSON.parse(localStorage.getItem('DataTables_accounts_page'))
        },
        drawCallback: function (settings) {
          $('.previous').html("<img src='/static/images/left_arrow.svg'>")
          $('.next').html("<img src='/static/images/right_arrow.svg'>")
          $('.first').addClass('d-inline')
          $('.first').html("<img src='/static/images/left_arrow.svg'><img src='/static/images/left_arrow.svg'>")
          $('.last').addClass('d-inline')
          $('.last').html("<img src='/static/images/right_arrow.svg'><img src='/static/images/right_arrow.svg'>")
        }
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Queries.vue